import React, { Fragment, useRef, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getLinks } from "../../../api/links/getLinks";
import { useAuth0 } from "../../../auth/Auth";
import { NAVBAR_TRANSITION_TIME } from "../../../constants/constants";
import { displayNameFormatter } from "../../../helpers/formatters";
import useApi2 from "../../../hooks/useApi2";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import LinkWithQueryParams from "../../LinkWithQueryParams";
import SignInBtn from "../SignInBtn";
import RequestDemoBtn from "../RequestDemoBtn";
import { stackWalker } from "../utils/stackWalker";
import UserInfo from "./UserInfo";
import { StyledNavbar_LP } from "./styles";
import { landingPageMenu } from "../../../pages/menu";
import styled from "styled-components";

const isTrueHelper = (c) => c && typeof c === "boolean";
const isFalseHelper = (c) => !c && typeof c === "boolean";

const NavbarLink = ({ submenu }) => {
  return submenu?.external ? (
    <a target="_blank" rel="noreferrer" href={submenu?.link}>
      {submenu.name}
    </a>
  ) : (
    <LinkWithQueryParams path={submenu.link}>
      {submenu.name}
    </LinkWithQueryParams>
  );
};

const Navbar_LP = () => {
  const isMobile = useCheckMobileScreen();
  const { isAuthenticated } = useAuth0();
  const { pathname } = useLocation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [closingMenu, setClosingMenu] = useState();
  //const [navLinks, setNavLinks] = useState([]);
  const user = useSelector((state) => state.user);
  const { data } = useApi2("space/my", { method: "GET" });
  const displayName = displayNameFormatter({ user });

  const menuLeft = useRef(null);
  const menuRight = useRef(null);
  const btnToggle = useRef(null);

  const activateOverlay = () => {
    const homeOverlay = document.querySelector("#home-overlay");
    const header = document.querySelector(".header_1");
    if (homeOverlay) homeOverlay.classList.toggle("active");
    if (header) header.classList.toggle("active");
    // btnToggle.current.classList.toggle("active");
    menuRight.current.classList.toggle("active");
  };

  React.useEffect(() => {
    if (isTrueHelper(closingMenu)) {
      menuRight.current.classList.toggle("slide-in");
      menuRight.current.classList.toggle("slide-out");
      const timeout = setTimeout(() => {
        menuRight.current.classList.toggle("slide-out");
      }, NAVBAR_TRANSITION_TIME);
      activateOverlay();
      return () => {
        clearTimeout(timeout);
      };
    }

    if (isFalseHelper(closingMenu)) {
      activateOverlay();
      menuRight.current.classList.toggle("slide-in");
    }
  }, [closingMenu]);

  /*const fetchLinks = async () => {
    const links = await getLinks();
    let navLinks = links?.length > 0 ? links : [];
    // filter for menu items that are not enabled by users not authenticated
    if (!isAuthenticated) {
      navLinks = stackWalker(landingPageMenu);
    }
    setNavLinks(navLinks);
  };*/

  let navLinks = landingPageMenu;

  if (!isAuthenticated) {
    navLinks = stackWalker(landingPageMenu);
  }

  /*React.useEffect(() => {
    fetchLinks();
  }, []);*/

  const menuToggle = () => {
    setClosingMenu(false);
  };

  const closeMenu = () => {
    setClosingMenu(true);
  };

  const handleOnClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <Fragment>
      <div className="mobile-button" ref={btnToggle} onClick={menuToggle}>
        <span></span>
      </div>
      <StyledNavbar_LP>
        <div className="mobile-nav" ref={menuRight}>
          <div id="close" onClick={closeMenu}>
            <span>x</span>
          </div>

          <ul>
            <Accordion allowZeroExpanded>
              {navLinks?.length > 0 &&
                navLinks?.map((data, index) => (
                  <AccordionItem
                    key={"accordion" + index}
                    className={
                      index % 2 ? "accordion-item" : "accordion-item light-blue"
                    }
                  >
                    {data.namesub?.length > 0 ? (
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <span>{data.name}</span>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                    ) : (
                      <>
                        <span>{data.name}</span>
                      </>
                    )}
                    <AccordionItemPanel>
                    {data.namesub && (
                    <ul className='menu-option'>
                      {data.namesub.map((submenu) => (
                        <li
                          key={submenu.id}
                          className={`
                          ${submenu.disabled ? 'disabled' : ''}
                            ${
                              pathname === submenu.links
                                ? 'menu-item current-item'
                                : 'menu-item'
                            }`}
                        >
                          <Link to={submenu.links}>{submenu.sub}</Link>
                        </li>
                      ))}
                    </ul>
              )}
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
            </Accordion>
          </ul>
          {/*<RequestDemoBtn />*/}
        </div>
      </StyledNavbar_LP>
      <HideForMobile>
      <nav id='main-nav' className='main-nav' ref={menuLeft}>
        <ul id='menu-primary-menu' className='menu'>
          {navLinks.map((data, index) => (
            <li
              key={index}
              onClick={() => handleOnClick(index)}
              className={`menu-item ${
                data.namesub ? 'menu-item-has-children' : ''
              } ${activeIndex === index ? 'active' : ''}`}
            >
              <Link to={data.links}>{data.name}</Link>
              {data.namesub && (
                <ul className='sub-menu'>
                  {data.namesub.map((submenu) => (
                    <li
                      key={submenu.id}
                      className={`
                        ${submenu.disabled ? 'disabled' : ''}
                        ${
                          pathname === submenu.links
                            ? 'menu-item current-item'
                            : 'menu-item'
                        }`}
                    >
                      <Link to={submenu.links}>{submenu.sub}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
        {/*<RequestDemoBtn />*/}
      </nav>
      </HideForMobile>
    </Fragment>
  );
};

const HideForMobile = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

export default Navbar_LP;
